// @flow

import {createPortal} from 'react-dom';

export const LayerPortal = ({children}: React.PropsWithChildren) => {
  const domNode =
    typeof document === 'object'
      ? document.getElementById('portal-root')
      : null;

  return domNode ? createPortal(children, domNode) : <>{children}</>;
};
